import { IBrand } from "@faire/web-api--source/indigofair/data/IBrand";

export const isOnlineOnlyRestricted = (
  brand?: Pick<IBrand, "forbids_online_only_retailers">,
  isOnlineOnlyRetailer?: boolean
): boolean | undefined => {
  return brand?.forbids_online_only_retailers && isOnlineOnlyRetailer;
};
